import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

interface IArrowStep1Props {
  color?: string;
}

function LocationIconTutorial(props: IArrowStep1Props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      accessibilityLabel={'location icon'}
    >
      <Path
        d="M17.786 9.424A5.787 5.787 0 0012 3.638a5.787 5.787 0 00-5.786 5.786c0 .498.181 1.27.615 2.298.422.997 1.02 2.098 1.708 3.21 1.145 1.857 2.47 3.649 3.463 4.926.996-1.277 2.322-3.07 3.463-4.925.688-1.113 1.286-2.214 1.708-3.21.434-1.03.615-1.8.615-2.299zm1.928 0c0 3.512-4.7 9.764-6.762 12.343a1.214 1.214 0 01-1.904 0c-2.061-2.58-6.762-8.831-6.762-12.343A7.716 7.716 0 0112 1.71a7.716 7.716 0 017.714 7.714zm-6.428 0a1.286 1.286 0 10-2.572 0 1.286 1.286 0 002.572 0zm-4.5 0a3.214 3.214 0 116.428 0 3.214 3.214 0 01-6.428 0z"
        fill="#fff"
      />
    </Svg>
  );
}

export default LocationIconTutorial;
